import { useUsageTracker } from 'marketplace-ui-common/tracking/context/UsageTrackerContext';
import { useMemo, useState } from 'react';
import StorefrontUsageTrackerContext from '../context/StorefrontUsageTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
const makeTrackEvent = (usageTracker, defaultEventProperties) => (eventName, eventProperties = {}) => {
  usageTracker.track(eventName, Object.assign({}, defaultEventProperties, eventProperties));
};
export default function StorefrontUsageTrackerProvider({
  children
}) {
  const tracker = useUsageTracker();
  const [defaultEventProperties, setDefaultEventProperties] = useState({});
  const usageTrackerContextValue = useMemo(() => {
    const trackEvent = makeTrackEvent(tracker, defaultEventProperties);
    return {
      trackEvent,
      trackPageview: trackEvent.bind(null, 'pageView'),
      trackDetailsPageview: trackEvent.bind(null, 'details-pageview'),
      trackFilterView: trackEvent.bind(null, 'storefront-filter-view'),
      trackInteraction: (action, eventProperties = {}) => trackEvent('interaction', Object.assign({}, eventProperties, {
        action
      })),
      trackDetailsInteraction: (action, eventProperties = {}) => trackEvent('details-interaction', Object.assign({}, eventProperties, {
        action
      })),
      setDefaultEventProperties
    };
  }, [tracker, defaultEventProperties]);
  return /*#__PURE__*/_jsx(StorefrontUsageTrackerContext.Provider, {
    value: usageTrackerContextValue,
    children: children
  });
}